__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "360-product-viewer";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.10.8", () => (Promise.all([__webpack_require__.e(9295), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(79295))))));
			register("@babylonjs/gui-editor", "9.3.0", () => (Promise.all([__webpack_require__.e(7262), __webpack_require__.e(1306), __webpack_require__.e(8146), __webpack_require__.e(7736), __webpack_require__.e(5058), __webpack_require__.e(346), __webpack_require__.e(5880), __webpack_require__.e(9434)]).then(() => (() => (__webpack_require__(25880))))));
			register("@babylonjs/gui", "9.3.0", () => (Promise.all([__webpack_require__.e(7262), __webpack_require__.e(2544)]).then(() => (() => (__webpack_require__(2544))))));
			register("@babylonjs/node-editor", "9.3.0", () => (Promise.all([__webpack_require__.e(7262), __webpack_require__.e(1306), __webpack_require__.e(8146), __webpack_require__.e(7736), __webpack_require__.e(5058), __webpack_require__.e(346), __webpack_require__.e(5662)]).then(() => (() => (__webpack_require__(35662))))));
			register("@reduxjs/toolkit", "2.6.1", () => (Promise.all([__webpack_require__.e(9277), __webpack_require__.e(4929)]).then(() => (() => (__webpack_require__(59277))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(8139).then(() => (() => (__webpack_require__(20520))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-loading-skeleton", "3.4.0", () => (Promise.all([__webpack_require__.e(318), __webpack_require__.e(3372)]).then(() => (() => (__webpack_require__(83372))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(3003), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(83003))))));
			register("react", "18.3.1", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(3923).then(() => (() => (__webpack_require__(23923))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};